export const MaintenancePage = () => {
  return (
    <div className="flex h-[100dvh] w-full items-center justify-center bg-purple">
      <div className="text-center px-4 flex flex-col items-center gap-4">
        <img src="/logo192.png" width="48" height="48" alt="up-logo" />
        <h1 className="text-xxl font-bold text-white mb-4">
          {`Maintenance Mode`}
        </h1>
        <p className="text-lg text-grey1">
          {`The platform is currently undergoing maintenance. Please check back
          later.`}
        </p>
      </div>
    </div>
  )
}
